import Vue from 'vue';
import '../theme/element.scss';
import {
  Table,
  TableColumn,
  Button,
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Select,
  Option,
  Pagination,
  InputNumber,
  Radio,
  RadioGroup,
  Switch,
  Upload,
  Input,
  Row,
  Col,
  Carousel,
  CarouselItem,
  Checkbox,
  CheckboxGroup,
  CheckboxButton,
  Loading,
  MessageBox,
  Message,
  Slider,
  Progress,
  Drawer,
  Collapse,
  CollapseItem,
  Image,
  Steps,
  Step,
  DatePicker
} from 'element-ui';

const components = [
  DatePicker,
  Table,
  TableColumn,
  Button,
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Select,
  Option,
  Pagination,
  InputNumber,
  Radio,
  RadioGroup,
  Switch,
  Upload,
  Input,
  Row,
  Col,
  Carousel,
  CarouselItem,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  CheckboxButton,
  Loading.directive,
  Slider,
  Progress,
  Drawer,
  Collapse,
  CollapseItem,
  Image,
  Step,
  Steps
];
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
components.forEach(component => Vue.use(component));
